module.exports = __webpack_public_path__ + "static/sumar@2x-83e5a257b89f388e4445c5201a610ea9.png";